<Dialog bind:value={showDialog} class="w-full md:w-1/2" {transitionProps}>
    <div slot="title" class="text-lg font-normal">Jääkide muutmine</div>
    <div class="w-full flex flex-wrap md:flex-nowrap">
        <div class="flex-grow md:mr-2">
            <TextField type="number" label="Pangakonto jääk" bind:value={userBalance.bankBalance} error={ValidationUtils.createErrors($userBalanceForm, 'bankBalance')}/>
        </div>
        <div class="flex-grow">
            <TextField type="number" label="Sularaha jääk" bind:value={userBalance.cashBalance} error={ValidationUtils.createErrors($userBalanceForm, 'cashBalance')}/>
        </div>
    </div>
    <div slot="actions">
        <Button color="secondary" on:click={() => showDialog = false}>Tühista</Button>
        <Button on:click={updateUserBalance} disabled="{!$userBalanceForm.valid}">Salvesta</Button>
    </div>
</Dialog>

<script lang="ts">
  import {Dialog, Button, TextField} from 'smelte';
  import {quadIn} from 'svelte/easing';
  import ApiService from '../api-service';
  import {snackbar} from '../stores';
  import {createEventDispatcher} from 'svelte';
  import {form} from 'svelte-forms';
  import ValidationUtils from '../utils/validation-utils';

  export let showDialog: boolean = false;
  export let userBalance: object = {
    cashBalance: null,
    bankBalance: null
  };

  const transitionProps = {duration: 150, easing: quadIn, delay: 0};
  const dispatch = createEventDispatcher();

  const userBalanceForm = form(() => ({
    cashBalance: {value: userBalance.cashBalance, validators: ['required', ValidationUtils.isNumber]},
    bankBalance: {value: userBalance.bankBalance, validators: ['required', ValidationUtils.isNumber]}
  }));

  $: formErrors = {
    'cashBalance': ValidationUtils.createErrors($userBalanceForm, 'cashBalance'),
    'bankBalance': ValidationUtils.createErrors($userBalanceForm, 'bankBalance')
  };

  async function updateUserBalance() {
    const response = await ApiService.updateUserBalance(userBalance);
    showDialog = false;
    dispatch('update:user-balance', response.data);
    snackbar.show('Muudatused salvestatud');
  }
</script>